import {ScreenConnectionWithTransportParams} from "./screen-connection-with-transport-params";

export class SupportScreenConnection extends ScreenConnectionWithTransportParams {
  screenName = 'support_screen';
}
